import { COMPONENT_NAME } from "@core/components/grid-data/grid-helper";

export const bathingGridConfig = {
    isLockPage: false,
    currentPage: 1,
    pageSize: 10,
    totalPage: 1,
    intervalTime: 30000,
    data: [],
    header: [
        {
            width: "1.5vw",
            fixedSize: true,
            items: [{ title: '' }],
            field: 'index',
            component: COMPONENT_NAME.LeaveComponent,
            config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "default" }
        },
        {
            width: "3vw",
            items: [{ title: '' }],
            field: 'priority',
            component: COMPONENT_NAME.StatusComponent,
            config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "default"}
        },
        {
            width: "14vw",
            items: [{ title: '名前' }],
            fixedSize: true,
            field: 'user',
            headerName: '名前',
            component: COMPONENT_NAME.UserInfoComponent,
            config: { isDarkMode: true, cellClass: "scrolling-text" }
        },
        {
            width: "12%",
            items: [{ title: '浴室名' }],
            field: 'bathRoomName',
            headerName: '浴室名',
            visible : false,
            component: COMPONENT_NAME.DynamicLabelComponent,
            config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "scrolling-text", whitespace: 'nowrap' }
        },
        {
            width: "15%",
            items: [{ title: '入浴方法' }],
            field: 'bathMethod',
            headerName: '入浴方法',
            component: COMPONENT_NAME.DynamicLabelComponent,
            config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "scrolling-text", whitespace: 'nowrap' }
        },
        {
            width: "8%",
            items: [{ title: '体温' }, { title: '脈拍' }],
            isSplitCell: true,
            subheader: [{
                width: "100%",
                items: [{ width: "50%", title: '血圧' }, { width: "50%", title: 'SPO2' }],
            }],
            field: 'vital',
            headerName: 'バイタル',
            component: COMPONENT_NAME.VitalComponent,
            config: { isDarkMode: true, cellClass: "scrolling-text" }
        },
        {
            width: "auto",
            items: [{ title: '処置、注意事項等' }],
            field: 'treatmentNoteMsg',
            headerName: '処置、注意事項等',
            component: COMPONENT_NAME.TextMarqueeComponent,
            config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "scrolling-text" }
        },
        {
            width: "auto",
            items: [{ title: '申し送り' }],
            field: 'attention_list',
            headerName: '申し送り',
            component: COMPONENT_NAME.TextMarqueeComponent,
            config: { isDarkMode: true, width: '100%', height: '100%', highlight: true, cellClass: "scrolling-text" }
        }
    ]
}